<ion-header *ngIf="showHeader">

    <ion-toolbar>
        <ion-title>Notizen</ion-title>
    </ion-toolbar>

</ion-header>

<div class="main">
    <form #nodeForm="ngForm" (submit)="saveNode(nodeForm)">
        <ion-row>
            <ion-col size="12" [attr.size-lg]="smallView ? 12 : 6 ">
                <ng2-smart-table (create)="newNote()" #table (delete)="deleteConfirm($event)" (userRowSelect)="rowSelect($event)"
                                 [settings]="settings" [source]="tableData"></ng2-smart-table>
            </ion-col>
            <ion-col size="12" [attr.size-lg]="smallView ? 12 : 6 ">
                <ion-item>
                    <ion-label  style="width:100px; max-width:100px;">{{'VisibleFrom' | translate}}:</ion-label>
                    
                    <app-ion-datetime style="display:contents;"
                            color="primary"
                            class="form-control"  
                            [(ngModel)]="formdata.from"
                            name="dateFrom" 
                            cancelText="{{ 'Cancel' | translate}}"
                            displayFormat="HH:mm"
                            doneText="{{ 'TakeOver' | translate }}"
                            [triggerId]="'dateFrom'"
                            [title]="'VisibleFrom' | translate"
                            presentation="time"
                            minuteValues="0,15,30,45"

                        >
                        </app-ion-datetime>

                        <ion-label style="width:35px; max-width:35px;">bis:</ion-label>

                        <app-ion-datetime style="display:contents;"
                            class="form-control"  
                            [(ngModel)]="formdata.to"
                            name="dateTo" 
                            cancelText="{{ 'Cancel' | translate}}"
                            displayFormat="HH:mm"
                            doneText="{{ 'TakeOver' | translate }}"
                            [triggerId]="'dateTo'"
                            [title]="'VisibleFrom' | translate"
                            presentation="time"
                            minuteValues="0,15,30,45"
                        >
                        </app-ion-datetime>
                </ion-item>
                <ion-item>
                    <ion-input [(ngModel)]="formdata.desc" name="desc" placeholder="Beschreibung" required></ion-input>
                </ion-item>
                <ion-item>
                    <ion-textarea [(ngModel)]="formdata.note" name="note" placeholder="Notiz" required></ion-textarea>
                </ion-item>
                <ion-item>
                    <ion-button type="submit" [disabled]="!nodeForm.valid" expand="block" size="large" class="full-width">Speichern</ion-button>
                </ion-item>
            </ion-col>
        </ion-row>
    </form>
</div>
